<template>
  <div v-loading="loading" class="ht-user-list">
    <template v-if="userList.length > 0">
      <user-card v-for="user in userList" :key="user.account" :user="user" />

      <div v-if="noMore" class="ht-user-list__no-more">
        <span>{{ $t('ht.common.noMore') }}</span>
      </div>

      <div v-else ref="loadingRef" class="ht-user-list__loading">
        <i class="el-icon-loading" />
      </div>
    </template>

    <el-empty v-else />
  </div>
</template>

<script>
  import UserCard from './component/UserCard.vue'
  import debounce from 'lodash/debounce'

  import { getUserList } from '@/api/user'
  import { addEventLog } from '@/api/base'

  export default {
    name: 'HtUserList',

    components: { UserCard },

    props: {
      pattern: {
        type: String,
        default: '',
      },
    },

    data() {
      return {
        page: 1,
        loading: false,
        noMore: false,
        userList: [],

        debouncedHandleLoadMore: debounce(this.handleLoadMore, 250),

        intersectionOb: null,
      }
    },

    watch: {
      pattern: {
        immediate: true,
        handler(val, oldVal) {
          if (val !== oldVal) {
            this.userList = []
            this.page = 1
            this.noMore = false

            this.intersectionOb = null
          }

          this.debouncedHandleLoadMore()
        },
      },
    },

    methods: {
      async handleLoadMore() {
        if (!this.pattern || this.noMore) return

        this.loading = true

        try {
          const pageSize = 50
          const { rows } = await getUserList(this.pattern, this.page, pageSize)

          if (rows.length < pageSize) {
            this.noMore = true
          }

          this.userList = [...this.userList, ...rows]

          // 等待2个事件循环，确保加载更多按钮渲染完成后再初始化IntersectionObserver
          setTimeout(() => {
            this.$nextTick(() => {
              this.initIntersectionOb()
            })
          }, 1000)
        } catch (e) {
          console.log(e)
        } finally {
          this.loading = false
          await addEventLog({
            type: '用户',
            content: this.pattern,
          })
        }
      },

      initIntersectionOb() {
        if (this.intersectionOb) return

        this.intersectionOb = new IntersectionObserver((entries) => {
          if (this.loading || this.noMore) return

          const entry = entries[0]

          if (!entry.isIntersecting) return

          this.page++
          this.handleLoadMore()
        })

        this.intersectionOb.observe(this.$refs.loadingRef)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .ht-user-list {
    height: 100%;
    overflow: hidden auto;

    &__no-more,
    &__loading {
      padding: 20px;
      font-size: 16px;
      color: #909399;
      text-align: center;

      i {
        font-size: 20px;
      }
    }
  }
</style>
